export const getParameterByName = (name) => {
  var match
  match = window.location.search.match(RegExp('[?&]' + name + '=([^&]*)'))
  if (match) {
    return decodeURIComponent(match[1].replace(+/g/, ' '))
  } else {
    return null
  }
}
